import React, { useState } from "react";
import { ContentFormHome, ContentFormSpecialities, ContentFormExpertise, ContentFormAbout, ContentFormNews, ContentFormWhoWeAre, ContentFormMissionAndVision, ContentFormCoreValues, ContentFormTestimonial, ContentFormCareers, ContentFormTeam, ContentFormPhysiotherapyAndOrthopedic, ContentFormRehabilitation, ContentFormNeurologyCentre, ContentFormPediatricRehabilitation, ContentFormBackCentre, ContentFormFootLab, ContentFormKneeCentre } from "../../FifthComponents";

const FifthDesignContentForm = () => {

    const [path, setPath] = useState('Home')
    return (
        <div>
            {path === 'Home' ? (
                <ContentFormHome path={path} setPath={setPath} />
            ) : path === 'Your Health & Our Specialities' ? (
                <ContentFormSpecialities path={path} setPath={setPath} />
            ) : path === 'About' ? (
                <ContentFormAbout path={path} setPath={setPath} />
            ) : path === 'News' ? (
                <ContentFormNews path={path} setPath={setPath} />
            ) : path === 'Who we are' ? (
                <ContentFormWhoWeAre path={path} setPath={setPath} />
            ) : path === 'Our Mission & Vision' ? (
                <ContentFormMissionAndVision path={path} setPath={setPath} />
            ) : path === 'Our Core Values' ? (
                <ContentFormCoreValues path={path} setPath={setPath} />
            ) : path === 'Testimonials' ? (
                <ContentFormTestimonial path={path} setPath={setPath} />
            ) : path === 'Careers' ? (
                <ContentFormCareers path={path} setPath={setPath} />
            ) : path === 'Our Team' ? (
                <ContentFormTeam path={path} setPath={setPath} />
            ) : path === 'Physiotherapy & Orthopedic' ? (
                <ContentFormPhysiotherapyAndOrthopedic path={path} setPath={setPath} />
            ) : path === 'Rehabilitation' ? (
                <ContentFormRehabilitation path={path} setPath={setPath} />
            ) : path === 'Neurology Centre of Expertise' ? (
                <ContentFormNeurologyCentre path={path} setPath={setPath} />
            ) : path === 'Pediatric Rehabilitation Program' ? (
                <ContentFormPediatricRehabilitation path={path} setPath={setPath} />
            ) : path === 'Back Centre of Expertise' ? (
                <ContentFormBackCentre path={path} setPath={setPath} />
            ) : path === 'Foot Lab & Gait Analysis Centre of Expertise' ? (
                <ContentFormFootLab path={path} setPath={setPath} />
            ) : path === 'Knee Centre of Expertise' ? (
                <ContentFormKneeCentre path={path} setPath={setPath} />
            ) : (
                <ContentFormExpertise path={path} setPath={setPath} />
            )}
        </div>
    )
}

export default FifthDesignContentForm